<template>
  <div class="item" @click="showModal">
    <div class="rectangle-row">
      <div class="col-sm-4 col-xl-4">
        <div class="product-price">{{ category.Price | formatMoney }}</div>
      </div>
      <div class="col-sm-8 col-xl-8">
        <div :class="{ 'gift-with-image': product.PhotoUrl }" class="item-details">
          <h5 class="item-title">{{ category.Name | camelCase }}</h5>
          <p v-html="product.ShortDescription">/p></p>
        </div>
      </div>

      <div
        :class="{
          new: product.Status == 1,
          popular: product.Status == 2,
          sold: product.Status == 3
        }"
        class="ibadge"
      >{{ product.Status | formatStatus }}</div>
      <details-popup
        v-if="isModalVisible"
        :price="category.Price"
        :product-id="category.ProductID"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
// import AddToCart from "./AddToCart";
import shared from "../../../sharedscripts/shop/products/Product.js";
import DetailsPopup from "./GiftAddToCart.vue";
export default {
  name: "Product",
  components: { DetailsPopup },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  watch: {
    isModalVisible() {}
  },
  methods: {
    showModal() {
      this.isModalVisible = this.product.Status != 3;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  }
};
</script>
